import { render, staticRenderFns } from "./ECommunicationConsent.vue?vue&type=template&id=61e5a73e"
import script from "./ECommunicationConsent.vue?vue&type=script&lang=js"
export * from "./ECommunicationConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports